import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Cell, DeprecatedIcon, Image, Spacer, Text } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import { actions } from 'state/user-feedback/slice';
import FeedbackThumbnail from './FeedbackThumbnail';
import FeedbackUsername from './FeedbackUsername';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const mapActionsToProps = {
  feedbackToggleCommentDelete: actions.feedbackToggleCommentDelete,
  feedbackToggleCommentEdit: actions.feedbackToggleCommentEdit
};
const connector = connect(null, mapActionsToProps);

class Comment extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "handleDelete", () => {
      const {
        id,
        feedbackToggleCommentDelete
      } = this.props;
      return feedbackToggleCommentDelete({
        feedbackId: id
      });
    });

    _defineProperty(this, "handleEdit", () => {
      const {
        id,
        feedbackToggleCommentEdit
      } = this.props;
      return feedbackToggleCommentEdit({
        feedbackId: id
      });
    });

    _defineProperty(this, "renderCommentActions", () => {
      const {
        canDeleteComment,
        canChangeComment
      } = this.props;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(SeparatedList, {
          children: [canChangeComment && /*#__PURE__*/_jsx(Button, {
            text: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "user.feedback.edit"
            }),
            deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
              name: "pencil",
              size: DeprecatedIcon.Size.XSmall,
              color: "parent"
            }),
            inline: true,
            size: Button.Size.Small,
            theme: "muted",
            onClick: this.handleEdit
          }), canDeleteComment && /*#__PURE__*/_jsx(Button, {
            text: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "user.feedback.delete"
            }),
            deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
              name: "x",
              size: DeprecatedIcon.Size.XSmall,
              color: "parent"
            }),
            inline: true,
            size: Button.Size.Small,
            theme: "muted",
            onClick: this.handleDelete
          })]
        })]
      });
    });
  }

  render() {
    const {
      user,
      text,
      isSystem
    } = this.props.comment;
    return /*#__PURE__*/_jsxs(Cell, {
      title: /*#__PURE__*/_jsx(FeedbackUsername, {
        user: user,
        isSystem: isSystem
      }),
      prefix: /*#__PURE__*/_jsx(FeedbackThumbnail, {
        user: user,
        size: Image.Size.Medium,
        isSystem: isSystem
      }),
      children: [/*#__PURE__*/_jsx(Text, {
        children: text
      }), this.renderCommentActions()]
    });
  }

}

export default connector(Comment);